import { Box, Tooltip, Typography } from '@mui/material';
import { InfoOutlined as FieldInfoIcon } from '@mui/icons-material';

/**
 * Ayudas de campo del módulo ERP — mismo patrón del ATS (AtsPositionWizard):
 * - InfoTip: ícono ⓘ con tooltip, para adjuntar a labels de switches,
 *   títulos de sección y encabezados de tabla.
 * - LabelWithInfo: etiqueta + ⓘ sobre controles sin label propio.
 * Los textos viven en i18n bajo erp.tooltips.* (es/en).
 */
export const InfoTip = ({ title }) => (
  <Tooltip title={title} placement="right">
    <FieldInfoIcon
      sx={{ fontSize: 15, color: 'text.secondary', ml: 0.5, verticalAlign: 'middle' }}
    />
  </Tooltip>
);

const LabelWithInfo = ({ label, tooltip }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Tooltip title={tooltip} placement="right">
      <FieldInfoIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
    </Tooltip>
  </Box>
);

export default LabelWithInfo;
